import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";
import { CONTENT } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/5 overflow-hidden">
      <div className="px-6 md:px-16 pt-16 md:pt-24 max-w-[1600px] mx-auto">
        <p className="font-display font-extrabold uppercase leading-[0.8] tracking-[-0.04em] text-[clamp(3.5rem,16.5vw,18rem)] text-stroke text-center select-none">
          {CONTENT.artist}
        </p>

        <div className="mt-16 md:mt-24 pb-16 flex flex-col md:flex-row md:items-start md:justify-between gap-12">
          <div className="max-w-xs">
            <p className="font-display font-extrabold uppercase tracking-tight text-xl text-[#f5f3ef]">TONE</p>
            <p className="mt-4 text-sm text-[#a3a3ac] font-light leading-relaxed">
              Emotionaler Techno.
              <br />
              Music, shows & everything in between.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-16 gap-y-10">
            <div>
              <p className="font-mono2 text-[10px] tracking-[0.35em] text-[#64646e] uppercase">Links</p>
              <nav className="mt-4 flex flex-col gap-3 font-mono2 text-[11px] tracking-[0.25em] uppercase">
                <Link data-testid="footer-link-datenschutz" to="/datenschutz" className="text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  Datenschutz
                </Link>
                <Link data-testid="footer-link-cookies" to="/datenschutz#cookies" className="text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  Cookies
                </Link>
                <Link data-testid="footer-impressum-link" to="/impressum" className="text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  Impressum
                </Link>
                <a data-testid="footer-booking-link" href={`mailto:${CONTENT.bookingEmail}`} className="text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  Contact / Booking
                </a>
              </nav>
            </div>

            <div>
              <p className="font-mono2 text-[10px] tracking-[0.35em] text-[#64646e] uppercase">Follow</p>
              <nav className="mt-4 flex flex-col gap-3 font-mono2 text-[11px] tracking-[0.25em] uppercase">
                <a data-testid="footer-instagram-link" href={CONTENT.instagram.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  <Instagram className="w-3.5 h-3.5" /> Instagram
                </a>
                <a data-testid="footer-spotify-link" href={CONTENT.streaming[0].url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  <ArrowUpRight className="w-3.5 h-3.5" /> Spotify
                </a>
                <a data-testid="footer-soundcloud-link" href={CONTENT.streaming[2].url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-[#a3a3ac] hover:text-[#70c7fa] transition-colors">
                  <ArrowUpRight className="w-3.5 h-3.5" /> SoundCloud
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="px-6 md:px-16 py-6 max-w-[1600px] mx-auto flex flex-wrap items-center justify-between gap-3 font-mono2 text-[10px] tracking-[0.3em] text-[#64646e] uppercase">
          <span>© 2026 TONE. All rights reserved.</span>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[#70c7fa] transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
